// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"2ca84613","329":"9f94a33d","453":"d4a61608","917":"206c33ed"}[chunkId] + ".chunk.js";
};